<template>
<div class="level">
  <div class="level-left">
    <svgicon
      class="level-item label-icon"
      name="action"
      color="#C4FFF9"
      width="20"
      height="20">
    </svgicon>
    <span class="level-item action-label">Actions</span>
    <b-checkbox
      v-model="alertSelected"
      class="level-item">
      Alert
    </b-checkbox>
    <b-checkbox
      v-model="logSelected"
      class="level-item">
      Log
    </b-checkbox>
    <b-checkbox
      v-model="cacheSelected"
      class="level-item">
      Cache
    </b-checkbox>
  </div>
</div>
</template>

<script>
export default {
  name: 'ActionsSelection',
  props: {
    actions: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    if (this.actions.includes('Alert')) {
      this.alertSelected = true;
    }
    if (this.actions.includes('Log')) {
      this.logSelected = true;
    }
    if (this.actions.includes('Cache')) {
      this.cacheSelected = true;
    }
  },
  data() {
    return {
      alertSelected: false,
      logSelected: false,
      cacheSelected: false,
    };
  },
  watch: {
    alertSelected() {
      this.$emit('update:actions', this.internalActions);
    },
    logSelected() {
      this.$emit('update:actions', this.internalActions);
    },
    cacheSelected() {
      this.$emit('update:actions', this.internalActions);
    },
  },
  computed: {
    internalActions() {
      const actions = [];
      if (this.alertSelected) actions.push('Alert');
      if (this.logSelected) actions.push('Log');
      if (this.cacheSelected) actions.push('Cache');
      return actions;
    },
  },
};
</script>

<style lang="scss" scoped>
.level-left svg.label-icon {
    margin-right: .5rem;
}
.action-label {
  font-weight: 500;
}
</style>
